<template>
  <ModalHolder :title="''" m-top="120" m-height="40vh" :is-show="isShowAlertModal">
    <template slot="mcontent">
      <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
        <Icon size="20" type="close-circled"></Icon>
      </span>
      <h3 align="center">You have been invited</h3><br/>
      <p align="center"><img alt=" " src="@/assets/logo.png" width="120px" height="120px"></p>
      <h4 align="center">Lorem Ipsum Dolor Ismet</h4>
    </template>
    <template slot="mfooter">
      <Button type="text">Decline</Button>
      <Button type="primary">Accept</Button>
      <span style="float:left">
        <router-link to="/coming-soon">
          <Button type="ghost">Learn More</Button>
        </router-link>
      </span>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";

export default {
  computed: {
    isShowAlertModal: {
      get() {
        return this.$store.state.base.isAlertModal
      }
    }
  },
  methods: {
    dismissModal() {
      this.$store.commit('base/setAlertModal', false);
    }
  },
  components: {
    ModalHolder
  }
}
</script>
